import React, { useState } from "react";
import CustomModal from "./CustomModal";
import CloseIcon from "../../../Common/Svgs/CloseIcon";

const ImagePreviewModal = ({ visible, onCancel, src }) => {
  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px">
      {/* prev: width="536px" */}
      <div
        className=""
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="flex items-center justify-between p-2">
          <div />
          <button type="button" className="" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <a
          href={src}
          className="flex w-[536px] h-[320px] items-center justify-center p-2 pt-0"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={src}
            alt="Preview"
            className="w-full h-full object-cover rounded-md overflow-hidden"
          />
        </a>
      </div>
    </CustomModal>
  );
};

const ImageWithPreview = ({ src, className, alt }) => {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setShowPreview(true)}
        className="border-0 bg-transparent p-0 cursor-pointer"
        aria-label="Preview image"
      >
        <img src={src} className={className} alt={alt} />
      </button>

      {showPreview && (
        <ImagePreviewModal
          visible={showPreview}
          onCancel={() => setShowPreview(false)}
          src={src}
        />
      )}
    </>
  );
};

export { ImagePreviewModal, ImageWithPreview };
